function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgTumblrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tumblr",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455.731 455.731",
    style: {
      enableBackground: "new 0 0 455.731 455.731"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    style: {
      fill: "#2F4F6E"
    },
    width: 455.731,
    height: 455.731
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.473,330.067v55.802c-0.103,0.043-0.214,0.086-0.317,0.129 c-6.631,3.105-13.374,5.953-20.228,8.544c-16.307,6.159-33.172,9.591-50.586,10.337c-1.536,0.06-3.071,0.163-4.615,0.24 c-3.371,0-10.56-0.086-10.791-0.094c-5.379-0.146-10.731-0.566-16.067-1.27c-8.758-1.167-17.311-3.165-25.598-6.271 c-13.168-4.915-24.774-12.198-34.399-22.527c-7.463-8.012-12.464-17.242-14.437-28.085c-1.501-8.278-2.093-16.616-2.093-25.006 c-0.034-41.613-0.017-84.179-0.017-125.792h-38.066v-50.749c4.212-1.664,8.445-3.122,12.554-5.027 c21.729-10.097,37.624-26.095,47.712-47.815c4.933-10.637,7.703-21.926,9.608-33.455c0.463-2.797,0.832-5.61,1.244-8.415h50.269 l0.017,89.806h84.102v55.656h-84.144c0,0,0.051,99.011,0.129,102.313c0.18,7.523,0.54,15.029,1.69,22.484 c1.244,8.012,5.25,14.223,12.001,18.666c6.614,4.349,13.914,6.837,21.772,7.678c7.815,0.841,15.57,0.249,23.264-1.304 C312.908,343.209,325.09,337.565,336.473,330.067z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblrIcon);
export default __webpack_public_path__ + "static/media/tumblr-icon.f96cb35b.svg";
export { ForwardRef as ReactComponent };